export const project = {
  title: "About this project",
  aboutP1:
    "The Mastercraft Bamboo Monitor Riser is a sturdy and stylish platform that elevates your screen to a more comfortable viewing height. Placing your monitor at eye level has the potential to improve your posture and make you more comfortable while at work, helping you stay focused on the task at hand.",
  aboutP2:
    "Featuring artisan craftsmanship, the simplicity of design creates extra desk space below your computer to allow notepads, pens, and USB sticks to be stored under the stand.",
  btnTextActive: "Select Reward",
  btnTextDisabled: "Out of Stock",
};
export const modal = {
  title: "Back this project",
  about:
    "Want to support us in bringing Mastercraft Bamboo Monitor Riser out in the world?",
};
export const cards = [
  {
    id: "0",
    title: "Pledge with no reward",
    pledgeCost: "",
    textAbout:
      "Choose to support us without a reward if you simply believe in our project. As a backer, you will be signed up to receive product updates via email.",
    countLeft: "",
    isDisabled: false,
  },
  {
    id: "1",
    title: "Bamboo Stand",
    pledgeCost: "25",
    textAbout:
      "You get an ergonomic stand made of natural bamboo. You've helped us launch our promotional campaign, and you’ll be added to a special Backer member list.",
    countLeft: "101",
    isDisabled: false,
  },
  {
    id: "2",
    title: "Black Edition Stand",
    pledgeCost: "75",
    textAbout:
      "You get a Black Special Edition computer stand and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
    countLeft: "64",
    isDisabled: false,
  },
  {
    id: "3",
    title: "Mahogany Special Edition",
    pledgeCost: "200",
    textAbout:
      "You get two Special Edition Mahogany stands, a Backer T-Shirt, and a personal thank you. You’ll be added to our Backer member list. Shipping is included.",
    countLeft: "0",
    isDisabled: true,
  },
];
